import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FlowServiceService } from "src/app/Services/flow-service.service";

@Component({
  selector: "app-flow-reviews-list-modal",
  templateUrl: "./flow-reviews-list-modal.component.html",
  styleUrls: ["./flow-reviews-list-modal.component.scss"],
})
export class FlowReviewsListModalComponent implements OnInit {
  flowData: any;
  reviews: any[] = [];
  isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<FlowReviewsListModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private flowServiceService: FlowServiceService
  ) {
    this.flowData = data.flowData;
  }

  ngOnInit() {
    this.loadReviews();
  }

  close() {
    this.dialogRef.close();
  }

  loadReviews() {
    if (!this.flowData?.rowKey) {
      this.reviews = [];
      return;
    }

    this.isLoading = true;
    this.flowServiceService
      .getFlowReviews({ FlowRowKey: this.flowData.rowKey })
      .subscribe(
        (data: any) => {
          this.reviews = data.reviews || data || [];
          this.isLoading = false;
        },
        (error) => {
          console.error("Error loading reviews:", error);
          this.reviews = [];
          this.isLoading = false;
        }
      );
  }

  getStarRating(rating: number): { filled: number; half: boolean } {
    const filled = Math.floor(rating || 0);
    const half = (rating || 0) - filled >= 0.5;
    return { filled, half };
  }

  formatDate(dateString: string): string {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  }
}

